import script from "./NcmCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./NcmCadastro.vue?vue&type=script&setup=true&lang=js"

import "./NcmCadastro.vue?vue&type=style&index=0&id=dc42565e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc42565e"]])

export default __exports__